import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import { useIntl } from 'react-intl';
import { FEATURE_SERVICES, FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import Button from 'shared/ui/Button';
import { Tag } from '../../styled';
import { setCreationTagModal } from 'Screens/Contextualization/Tags/actions/Actions';
import ModalWarning from 'Common/Components/ModalWarning';

const TagButton = ({ hasItems, servicesSelected, tagsEntity, selectAll, entity }) => {
  const dispatch = useDispatch();
  const [showWarning, setShowWarning] = useState(false);
  const readonly = useSelector((state) => get(state, 'faraday.readonly', false));
  const canCreateTags = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.CREATE));
  const canPatchServices = useSelector((state) => selectAllowedByRole(state, FEATURE_SERVICES, PERMISSION_TYPES.PATCH));
  const canUpdate = entity !== 'servicesGeneral'
    ? canCreateTags && canPatchServices && !readonly && hasItems && !selectAll
    : canCreateTags && canPatchServices && hasItems && !selectAll;
  const intl = useIntl();
  const message = intl.formatMessage({ id: 'modalWarning.selectOneOrMore' }, { entity: 'assets' });

  const handleClick = () => {
    if (canUpdate) {
      if ((servicesSelected.length > 0)) dispatch(setCreationTagModal(true, tagsEntity));
      else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  if (!canCreateTags) return null;

  return (
    <>
      <Button variant="ghost" startIcon={ <Tag /> } title="Tags" ariaLabel="Tags" onClick={ handleClick } disabled={ !canUpdate } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Tags" description={ message } /> }
    </>
  );
};

export default TagButton;
